/**
 * The labels and hint text for a skill version's two fields, in one place.
 *
 * Read mode and edit mode both render these. They used to carry their own
 * strings, which drifted: the reader saw "Procedure" where the editor said
 * "Procedure / body" (the API's field name leaking into the UI), and the hints
 * explaining what each field is *for* existed only in edit mode — so a reader
 * was told nothing about which text the AI actually matches on.
 *
 * The character budget is deliberately not part of {@link WHEN_TO_USE_HINT}:
 * it's only actionable while typing, so the editor appends
 * {@link whenToUseEditHint} instead of putting a count in front of readers.
 */

import { SKILL_DESCRIPTION_MAX_LENGTH } from "@/shared/domain/skills";

export const WHEN_TO_USE_LABEL = "When to use";

export const WHEN_TO_USE_HINT =
  "Short description the AI uses to decide when to apply this skill.";

export const PROCEDURE_LABEL = "Procedure";

export const PROCEDURE_HINT =
  "Markdown supported. Type “[[” to reference a topic — referenced topics are pre-loaded for the AI.";

/** {@link WHEN_TO_USE_HINT} plus the length cap the editor enforces. */
export function whenToUseEditHint(): string {
  return `${WHEN_TO_USE_HINT} (≤${SKILL_DESCRIPTION_MAX_LENGTH} chars)`;
}
